import { render, staticRenderFns } from "./OtherHouseDeposit.vue?vue&type=template&id=f155f83e&scoped=true&"
import script from "./OtherHouseDeposit.vue?vue&type=script&lang=js&"
export * from "./OtherHouseDeposit.vue?vue&type=script&lang=js&"
import style0 from "./OtherHouseDeposit.vue?vue&type=style&index=0&id=f155f83e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f155f83e",
  null
  
)

export default component.exports